import Toaster from "global/component/Genericos/Toaster/Toaster";
import { GlobalContext } from "global/context/Provider";
import { useContext } from "react";
import TazaIcon from "_+_Portal/assets/images/generico/TazaIcon";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";

import {
  ContainerFilaVirtualMasInfoCasa,
  FilaVirtualMasInfoCasaBotones,
  FilaVirtualMasInfoCasaConoceMasTxt,
  FilaVirtualMasInfoCasaIcono,
  FilaVirtualMasInfoCasaTitulo,
  FilaVirtualMasInfoCasaTxt,
} from "./localStyle";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import { getLocalStorage } from "global/utils/safeJsonParse";

const FilaVirtualMasInfoCasa = ({ setError, turnoActual }) => {
  // -------------------------  useContex  ----------------------------
  const { pasoDispatch, turnosSeleccionadosState } =
    useContext(AutocheckContext);
  const { toasterState } = useContext(GlobalContext);

  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  let idTerminal = getLocalStorage("idTerminal");
  
  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];

  const turno = listTurnosSeleccionado[turnoActual];

  const medico = turno?.medico;
  const especialidad = turno?.especialidad;

  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------

  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    setPaso("FilaVirtualCasa")(pasoDispatch);
  };
  const irATurnos = () => {
    if (idTerminal) {
      setPaso("TurnosRecepcionados")(pasoDispatch);
    } else {
      setPaso("TurnosRecepcionadosQR")(pasoDispatch);
    }
  };

  // -------------------------  funciones  ----------------------------

  return (
    <LayoutPasos handleClick={volver} type={"no-circle"} title={"FILA VIRTUAL"}>
      {toasterState.toaster.show && <ToasterV2 />}
      <ContainerFilaVirtualMasInfoCasa>
        <CardBlueHeart
          medico={medico ? medico : especialidad}
          turnoTitle={especialidad}
          pasoActual={turnoActual + 1}
          pasoTotal={listTurnosSeleccionado.length}
        />
        <FilaVirtualMasInfoCasaTitulo>
          <span className="rb18l">
            Para que puedas usar mejor tu tiempo, creamos la fila virtual.
          </span>
        </FilaVirtualMasInfoCasaTitulo>
        <FilaVirtualMasInfoCasaIcono>
          <TazaIcon />
        </FilaVirtualMasInfoCasaIcono>
        <FilaVirtualMasInfoCasaTxt>
          <span className="rb18l">
            Hace lo que necesites y nosotros te avisamos cuando se acerque la
            hora
          </span>
        </FilaVirtualMasInfoCasaTxt>
        <FilaVirtualMasInfoCasaConoceMasTxt>
          <span className="rb18b">
            Es importante activar las notificaciones de nuestra APP.
          </span>
          <span className="FilaVirtualMasInfoConoceMasTxt rb18b">
            Mira como hacerlo acá
          </span>
        </FilaVirtualMasInfoCasaConoceMasTxt>
        <FilaVirtualMasInfoCasaBotones>
          <div onClick={volver} className="btn bgc-primary c-white">
            Volver
          </div>
          <div onClick={irATurnos} className="btn bgc-broccoli c-white">
            Ir a turnos
          </div>
        </FilaVirtualMasInfoCasaBotones>
      </ContainerFilaVirtualMasInfoCasa>
    </LayoutPasos>
  );
};

export default FilaVirtualMasInfoCasa;
